import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomPowerLevelsMessageProps {
  message: IMatrixMessage;
  className?: string;
}

export const RoomPowerLevelsMessage = ({ message, className = '' }: RoomPowerLevelsMessageProps) => {
  const sender = message.sender;
  return (
    <div className={`room-power-levels-message ${className}`} style={{ color: '#c62828', padding: '8px 0' }}>
      {sender ? `${sender} 修改了房间权限设置` : `房间权限设置被修改`}
    </div>
  );
}; 